import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Table, Card, Empty, Button, Icon, Modal, Spin } from 'antd';

// Actions
import { fetchInvitedUsers, handleDeleteInvitedUser } from '../../../data/homes/actions';

// Selectors
import {
    isOwnerOfCurrentlyLoadedHouse,
    getInvitedUsersList,
    getInvitedUsersAreLoading
} from '../../../data/homes/selectors';

// Others
import { strings } from '../../../localization';

const ButtonGroup = Button.Group;

class InvitedUsersTable extends PureComponent {
    state = {
        deleteModalShown: false,
        deleteModalIsLoading: false,
        recordToDelete: null
    };

    componentWillMount() {
        const { fetchInvitedUsers, params } = this.props;
        fetchInvitedUsers(params);
    }

    onDeleteModalShownToggle = (isShown, record) => () => {
        this.setState({ deleteModalShown: isShown, recordToDelete: record || null });
    };

    onDeleteModalStateReset = () => {
        this.setState(() => ({
            deleteModalShown: false,
            deleteModalIsLoading: false,
            recordToDelete: null
        }));
    };

    onDeleteUser = () => {
        this.setState({ deleteModalIsLoading: true });

        const { recordToDelete } = this.state;
        const { params, fetchInvitedUsers, handleDeleteInvitedUser } = this.props;
        handleDeleteInvitedUser(recordToDelete.id, params).then(() => {
            this.onDeleteModalStateReset();
            fetchInvitedUsers(params);
        });
    };

    render() {
        const { isOwnerOfHouse, invitedUsersList, invitedUsersAreLoading } = this.props;
        const { recordToDelete, deleteModalShown, deleteModalIsLoading } = this.state;

        if (!isOwnerOfHouse) return null;

        const columns = [
            {
                title: strings.homes.detail.userEmail,
                dataIndex: 'email',
                key: 'email'
            },
            {
                title: strings.actionsLabel,
                key: 'action',
                fixed: 'right',
                width: 200,
                render: (text, record) => (
                    <span style={{ float: 'right' }}>
                        <ButtonGroup style={{ marginLeft: 10 }}>
                            <Button type="danger" onClick={this.onDeleteModalShownToggle(true, record)}>
                                <Icon type="delete" />
                            </Button>
                        </ButtonGroup>
                    </span>
                )
            }
        ];

        return [
            <Card
                loading={invitedUsersAreLoading}
                key="invited-users-table-card"
                style={{ marginTop: 30 }}
                bodyStyle={{ padding: 0 }}
                title={strings.homes.detail.invitedUsers}
            >
                {invitedUsersList && invitedUsersList.size > 0 ? (
                    <Table
                        pagination={false}
                        dataSource={[...(invitedUsersList ? invitedUsersList.toJS() : [])]}
                        columns={columns}
                    />
                ) : (
                    <Empty
                        description={<span>{strings.noDataAvailable}</span>}
                        style={{ margin: '30px auto' }}
                    />
                )}
            </Card>,
            recordToDelete && (
                <Modal
                    key="delete-user-modal"
                    visible={deleteModalShown}
                    onCancel={this.onDeleteModalStateReset}
                    onOk={this.onDeleteUser}
                    okText={strings.delete}
                    okType="danger"
                    confirmLoading={deleteModalIsLoading}
                    cancelText={strings.cancel}
                    title={strings.sureToDeleteTitle}
                >
                    <Spin spinning={deleteModalIsLoading} size="large">
                        <div>
                            <p>
                                {strings.homes.detail.sureToDeleteContent}{' '}
                                <strong>{recordToDelete.email}</strong>?
                            </p>
                        </div>
                    </Spin>
                </Modal>
            )
        ];
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isOwnerOfHouse: isOwnerOfCurrentlyLoadedHouse(state),
        invitedUsersList: getInvitedUsersList(state),
        invitedUsersAreLoading: getInvitedUsersAreLoading(state)
    }),
    {
        fetchInvitedUsers,
        handleDeleteInvitedUser
    }
)(InvitedUsersTable);
